import React, { useEffect } from 'react';
import $ from 'jquery';
import * as R from 'ramda'

export const Help = ({row}) => {
	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);
		return (
			<nav className={"nav h-auto text-right" + (row && " flex-shrink-0")}>
				<div className={R.isNil(row) ? "container-fluid mt-1" : ""}>
					<h1 className="sr-only visually-hidden">Help</h1>
					<span className="small font-weight-bold"><span data-toggle="tooltip" data-placement="top" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
						title="Vous devez compléter 100% des service sélectionnés afin d’accéder à l’espace suivant<br /><br />
							Question :<br />
							<strong>Vous ne retrouvez pas la référence ?</strong><br /><br />
							1 - Supprimer la sélection afin de prendre le temps de rechercher celle-ci (3 mois pour créer des courriers)<br /><br />
							2 - Mettre le nom et prénom du défunt dans référence (service non optimisé)"
						data-html="true">Besoin d'aide ?</span> <a className="text-info" href="/faqs">FAQ</a></span>
				</div>
			</nav>
		)
	};